import { NUMBER_TYPE_ERROR_MSG } from 'src/utils/constants';
import { getMaxLimitErrorMsg } from 'src/utils/getInitials';
import * as Yup from 'yup';

// vehicle record form model
export const vehicleRecordFormModel = {
  formId: 'vehicleRecordConfig',
  formField: {
    vehicleNumber: {
      name: 'vehicle',
      label: 'Select Vehicle',
      requiredErrorMsg: 'Vehicle selection is required',
      type: 'select',
      data: []
    },
    shift: {
      name: 'shift',
      label: 'Select Shift',
      requiredErrorMsg: 'Shift selection is required',
      type: 'select',
      data: []
    },
    openingReading: {
      name: 'opening_reading',
      label: 'Opening Reading',
      requiredErrorMsg: 'Opening Reading is required',
      invalidErrorMsg: 'Opening Reading is Invalid',
      type: 'text',
    },
    closingReading: {
      name: 'closing_reading',
      label: 'Closing Reading',
      requiredErrorMsg: 'Closing Reading is required',
      invalidErrorMsg: 'Closing Reading is Invalid',
      type: 'text',
    },
    runningHour: {
      name: 'running_hours',
      label: 'Running Hours',
      requiredErrorMsg: 'Running Hours is required',
      invalidErrorMsg: 'Running Hours is Invalid',
      type: 'text',
    },
    trips: {
      name: 'number_of_trips',
      label: 'Total Trips',
      requiredErrorMsg: 'Total Trips is required',
      invalidErrorMsg: 'Total Trips is Invalid',
      type: 'text',
    },
    quantity: {
      name: 'quantity',
      label: 'Quantity',
      requiredErrorMsg: 'Quantity is required',
      invalidErrorMsg: 'Quantity is Invalid',
      type: 'text',
    },
    hsd: {
      name: 'hsd',
      label: 'HSD',
      requiredErrorMsg: 'HSD Trips is required',
      invalidErrorMsg: 'HSD Trips is Invalid',
      type: 'text',
    },
    recordDate: {
      name: 'date',
      label: 'Select Date',
      requiredErrorMsg: 'Select Date is required',
      invalidErrorMsg: 'Select Date is Invalid',
      type: 'text',
    },
  }
};

// Initial values
const {
  formField: {
    vehicleNumber,
    shift,
    openingReading,
    closingReading,
    runningHour,
    trips,
    quantity,
    hsd,
    recordDate
  }
} = vehicleRecordFormModel;

export const vehicleRecordFormInitialValues = {
  [vehicleNumber.name]: '',
  [shift.name]: '',
  [openingReading.name]: 0,
  [closingReading.name]: 0,
  [runningHour.name]: 0,
  [trips.name]: 0,
  [quantity.name]: 0,
  [hsd.name]: 0,
  [recordDate.name]: ''
};

// validation schema
export const vehicleRecordValidationSchema = Yup.object().shape({
  [vehicleNumber.name]: Yup.string().required(vehicleNumber.requiredErrorMsg),
  [shift.name]: Yup.string().required(shift.requiredErrorMsg),
  [openingReading.name]: Yup.number().typeError(NUMBER_TYPE_ERROR_MSG).max(9999, getMaxLimitErrorMsg(openingReading, 9999))
    .required(openingReading.requiredErrorMsg),
  [closingReading.name]: Yup.number().typeError(NUMBER_TYPE_ERROR_MSG).max(9999, getMaxLimitErrorMsg(closingReading, 9999))
    .required(closingReading.requiredErrorMsg),
  [runningHour.name]: Yup.number().typeError(NUMBER_TYPE_ERROR_MSG).max(9999, getMaxLimitErrorMsg(runningHour, 9999))
    .required(runningHour.requiredErrorMsg),
  [trips.name]: Yup.number().typeError(NUMBER_TYPE_ERROR_MSG).max(9999, getMaxLimitErrorMsg(trips, 9999))
    .required(trips.requiredErrorMsg),
  [quantity.name]: Yup.number().typeError(NUMBER_TYPE_ERROR_MSG).max(9999, getMaxLimitErrorMsg(quantity, 9999))
    .required(quantity.requiredErrorMsg),
  [hsd.name]: Yup.number().typeError(NUMBER_TYPE_ERROR_MSG).max(9999, getMaxLimitErrorMsg(hsd, 9999))
    .required(hsd.requiredErrorMsg),
  [recordDate.name]: Yup.date().nullable().required(recordDate.requiredErrorMsg),
});
